export const EMPTY_MODEL_MSG =
  "Empty model response — the chat backend did not return text. Sign in and retry.";

export const GGUF_NEEDS_ENDPOINT_MSG =
  "This backend is a GGUF pack that needs a dedicated inference box. Sign in and retry.";

export const NO_TARGET_MSG =
  "Cannot reach the chat backend. Sign in and retry.";

function looksLikeHtml(body: string): boolean {
  const t = body.trimStart().slice(0, 200).toLowerCase();
  return t.startsWith("<!doctype") || t.startsWith("<html") || t.includes("<head>");
}

export function unwrapInferenceErrorBody(body: string): string {
  let raw = (body || "").trim();
  if (!raw) return "";
  if (/^data:\s*/i.test(raw) || raw.includes("\ndata:")) {
    const line =
      raw
        .split(/\r?\n/)
        .map((l) => l.trim())
        .find((l) => /^data:\s*/i.test(l) && !/^data:\s*\[done\]/i.test(l)) || raw;
    raw = line.replace(/^data:\s*/i, "").trim();
  }
  for (let i = 0; i < 5; i++) {
    const t = raw.trim();
    if (!t.startsWith("{") && !t.startsWith("[")) break;
    try {
      const j = JSON.parse(t) as unknown;
      if (typeof j === "string") {
        raw = j;
        continue;
      }
      if (!j || typeof j !== "object") break;
      const obj = j as Record<string, unknown>;
      const err = obj.error;
      let next = "";
      if (typeof err === "string") next = err;
      else if (err && typeof err === "object") {
        const e = err as Record<string, unknown>;
        if (typeof e.message === "string") next = e.message;
      }
      if (!next && typeof obj.message === "string") next = obj.message;
      if (!next || next === raw) break;
      raw = next;
    } catch {
      break;
    }
  }
  return raw.trim();
}

export function explainLlmHttpError(status: number, body: string, requestUrl: string): string {
  const unwrapped = unwrapInferenceErrorBody(body || "");
  const lower = unwrapped.toLowerCase();
  const relayUrl = /bookforge-relay|forgesuiteui/i.test(requestUrl);
  if (status === 402 || /balance_too_low|insufficient/i.test(lower)) {
    return unwrapped || "Insufficient suite credits. Add credits, then retry.";
  }
  if (status === 401 || status === 403) {
    return relayUrl
      ? `Auth failed (HTTP ${status}). Sign in and retry.`
      : `Auth failed (HTTP ${status}). ${unwrapped || ""}`.trim();
  }
  if (status === 404) {
    return `Endpoint not found (HTTP ${status}). Sign in and retry.`;
  }
  if (status === 502 || status === 503) {
    return `Endpoint not ready (HTTP ${status}). Model may still be cold-starting — wait and retry.`;
  }
  if (unwrapped && !looksLikeHtml(unwrapped) && !unwrapped.startsWith("{")) {
    return unwrapped.slice(0, 320);
  }
  return `LLM HTTP ${status}: ${unwrapped.slice(0, 220) || `status ${status}`}`;
}
